import React from 'react';
import './WhyChooseUs.css';
import featureImg from '../../assets/img/feature.jpg';

const WhyChooseUs = () => {
  return (
    <div className="container-fluid bg-image py-5">
      <div className="container py-5">
        <div className="row align-items-center">
          {/* Left Content */}
          <div className="col-lg-7">
            <div className="section-title mb-4">
              <h6 className="text-secondary text-uppercase">Why Choose Us?</h6>
              <h1 className="main-heading">Why You Should Start Learning with Us?</h1>
            </div>

            {/* ✅ Main Paragraph */}
            <p className="desc mb-4">
              We provide a structured and flexible learning environment where students of all backgrounds can access top-quality education. Our platform bridges the gap between academic knowledge and practical skills, preparing you for real-world success.
            </p>

            {/* ✅ Feature 1 */}
            <div className="feature-box mb-4">
              <div className="icon bg-primary">
                <i className="fa fa-graduation-cap text-white"></i>
              </div>
              <div>
                <h5>Skilled Instructors</h5>
                <p>
                  Learn from certified educators and industry professionals who bring real-world experience to every class. Our instructors are passionate about teaching and dedicated to your personal growth.
                </p>
              </div>
            </div>

            {/* ✅ Feature 2 */}
            {/* <div className="feature-box mb-4">
              <div className="icon bg-secondary">
                <i className="fa fa-certificate text-white"></i>
              </div>
              <div>
                <h5>Recognized Certifications</h5>
                <p>
                  Upon successful course completion, you’ll receive certificates that are accepted by leading companies and educational institutions—boosting your resume and career prospects.
                </p>
              </div>
            </div> */}

            {/* ✅ Feature 3 */}
            <div className="feature-box">
              <div className="icon bg-warning">
                <i className="fa fa-book-reader text-white"></i>
              </div>
              <div>
                <h5>Flexible Online Classes</h5>
                <p>
                  Our live and recorded sessions are designed to fit your schedule. Whether you’re a full-time student or a working professional, you can learn anytime, anywhere at your own pace.
                </p>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="col-lg-5 mt-5 mt-lg-0">
            <div className="image-wrapper">
              <img src={featureImg} alt="Feature" className="img-fluid rounded shadow" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;
